import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _pick from "lodash/pick";
import _isNil from "lodash/isNil";
import _map from "lodash/map";
import _groupBy from "lodash/groupBy";
import _get from "lodash/get";
import _identity from "lodash/identity";
import _flatMap from "lodash/flatMap";
import _shuffle from "lodash/shuffle";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { Converter } from 'showdown';
import { getItemsSolution } from '../sct/solution';
const converter = new Converter();
const convertToHtml = message => converter.makeHtml(message);
const normalizeItem = target => data => ({
  content: data.content,
  htmlContent: convertToHtml(data.content),
  id: data.id,
  language: data.language,
  offset: 0,
  target
});
export default exercise => {
  const {
    correctnessConditions,
    solution: solutionEntity
  } = exercise.question;
  const items = _shuffle(_flatMap(solutionEntity, 'draggableItems').filter(_identity).map(normalizeItem(_get(solutionEntity, [0, 'id']))));
  const initialGroupedItems = _groupBy(items, 'target');
  const solutionData = _flatMap(solutionEntity, target => _map(target.draggableItems, item => ({
    id: item.id,
    offset: _get(item, 'offset'),
    target: target.id
  })));
  const itemsSolution = getItemsSolution(solutionData, items);
  const scts = _objectSpread(_objectSpread({}, correctnessConditions), {}, {
    checks: _map(correctnessConditions.checks, check => _objectSpread(_objectSpread({}, check), {}, {
      message: convertToHtml(check.message)
    })),
    failureMessage: _isNil(correctnessConditions.failureMessage) ? undefined : convertToHtml(correctnessConditions.failureMessage),
    successMessage: convertToHtml(correctnessConditions.successMessage)
  });
  const targets = _map(solutionEntity, target => _objectSpread({
    maxOffset: 0
  }, _pick(target, ['id', 'title', 'maxOffset', 'language'])));
  return {
    initialGroupedItems,
    itemsSolution,
    scts,
    targets
  };
};